import { useEffect, useState, useCallback } from "react";
import { ShowToast } from "../helper/toast";

function useApi({
  callback = () => {},
  dependencies = [],
  payload = "",
  shouldCallApi = true,
  onSuccess = () => {},
  onError = () => {},
  setLoading = null,
}) {
  const [data, setData] = useState({
    error: false,
    data: [],
    loading: true,
    catch: null,
  });

  const memoizedCallback = useCallback(callback, [callback]);

  useEffect(() => {
    if (!navigator.onLine) {
      return ShowToast("No internet connection", "error");
    }
    if (!memoizedCallback || !shouldCallApi) return;

    if (typeof setLoading === "function") {
      setLoading(true);
    }
    setData((pre) => ({ ...pre, loading: true }));

    const fetchData = async () => {
      try {
        const reqPayload = Array.isArray(payload) ? payload : [payload];
        const res = await memoizedCallback(...reqPayload);
        setData({ error: false, data: res, loading: false, catch: null });
        if (typeof setLoading === "function") {
          setLoading(false);
        }
        if (res.data && onSuccess) {
          onSuccess(res.data);
        }
      } catch (error) {
        // console.error(error);
        console.log("error === useApi", error);
        if (typeof setLoading === "function") {
          setLoading(false);
        }
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("userProfile");
          localStorage.removeItem("permission");
          window.location.replace("/login");
        }
        if (onError) onError(error?.response?.data?.message);
        setData({ error: true, data: [], loading: false, catch: error });
      }
    };

    fetchData();
  }, [memoizedCallback, shouldCallApi, ...dependencies]);

  return data;
}

export default useApi;
